import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _templateObject;
var _excluded = ["dealroomId"],
  _excluded2 = ["isOpen"],
  _excluded3 = ["selectedItem", "helperText"];
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
//@ts-nocheck
import { Icon, Table, TableBody, TableRow, TableCell, withStyles, Typography, RaiseColors } from "components/mui";
import { StatusBadge } from "componentLibrary";
import { gql } from "@apollo/client";
import * as React from "react";
import numberWithCommas from "core/Utils/numberWithCommas";
import { SelectableNodeEnum } from "utils/Enums";
import { WorkFlowStatusEnum } from "utils/Enums/index";
import DefaultAutocompleteInputField from "../../Fields/AutoComplete/DefaultAutocompleteInputField";
import DefaultSuggestionsPopper from "../../Fields/AutoComplete/DefaultSuggestionsPopper";
import AsyncSelect from "../AsyncSelect/AsyncSelect";
import CompSelectFragment__CompNode from "./CompSelectFragment__CompNode";
import NumberFormatter from "components/Formatters/NumberFormatter/NumberFormatter";
import { useCompSelectSearchQuery } from "raise-types";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CompSelect = function CompSelect(_ref) {
  var dealroomId = _ref.dealroomId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(10),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    first = _React$useState2[0],
    setFirst = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    inputValue = _React$useState4[0],
    setInputValue = _React$useState4[1];
  var _useCompSelectSearchQ = useCompSelectSearchQuery({
      variables: {
        first: first,
        searchBy: inputValue || null,
        filterBy: _JSON$stringify({
          is_lease: true
        })
      },
      fetchPolicy: "cache-and-network"
    }),
    data = _useCompSelectSearchQ.data,
    loading = _useCompSelectSearchQ.loading,
    error = _useCompSelectSearchQ.error;
  if (error) {
    return /*#__PURE__*/_jsx(Typography, {
      children: "Error Fetching Data"
    });
  }
  var onInputValueChange = function onInputValueChange(inputValue, stateAndHelpers) {
    setFirst(10);
    setInputValue(inputValue);
  };
  var dlFilterBy = dealroomId ? _JSON$stringify({
    dealroom__id: dealroomId,
    work_flow_status: WorkFlowStatusEnum.IN_DEALROOM.value
  }) : undefined;
  var props = _objectSpread(_objectSpread({
    nodeType: SelectableNodeEnum.COMPS.name,
    placeholder: "Search for a comp"
  }, rest), {}, {
    renderSuggestions: function renderSuggestions(_ref2) {
      var isOpen = _ref2.isOpen,
        props = _objectWithoutProperties(_ref2, _excluded2);
      return /*#__PURE__*/_jsx(DefaultSuggestionsPopper, _objectSpread(_objectSpread({}, props), {}, {
        open: isOpen,
        loading: loading,
        SuggestionsComponent: function SuggestionsComponent(props) {
          var _context, _data$allComps$edges, _data$allComps$pageIn;
          return /*#__PURE__*/_jsx(OptionsTable, _objectSpread({
            dlFilterBy: dlFilterBy,
            comps: _mapInstanceProperty(_context = (_data$allComps$edges = data === null || data === void 0 ? void 0 : data.allComps.edges) !== null && _data$allComps$edges !== void 0 ? _data$allComps$edges : []).call(_context, function (e) {
              return e.node;
            }),
            onLoadMore: function onLoadMore() {
              return setFirst(function (prev) {
                return prev + 10;
              });
            },
            hasMore: (_data$allComps$pageIn = data === null || data === void 0 ? void 0 : data.allComps.pageInfo.hasNextPage) !== null && _data$allComps$pageIn !== void 0 ? _data$allComps$pageIn : false,
            loading: loading
          }, props));
        },
        disablePortal: true
      }));
    },
    renderInputField: CompInputField,
    onInputValueChange: onInputValueChange
  });
  return /*#__PURE__*/_jsx(AsyncSelect, _objectSpread({}, props));
};
export default CompSelect;

/* use a custom renderer to show listing information as input field help text */
function CompInputField(_ref3) {
  var _context2;
  var comp = _ref3.selectedItem,
    helperText = _ref3.helperText,
    props = _objectWithoutProperties(_ref3, _excluded3);
  if (!comp || helperText) {
    // cant add helper text without the ML,
    // and dont want to override error helper text
    return /*#__PURE__*/_jsx(DefaultAutocompleteInputField, _objectSpread(_objectSpread({}, props), {}, {
      helperText: helperText
    }));
  }
  var compInfoHelperText = _concatInstanceProperty(_context2 = "".concat(numberWithCommas(comp.sqft), " sqft ")).call(_context2, comp.leaseType);
  return /*#__PURE__*/_jsx(DefaultAutocompleteInputField, _objectSpread(_objectSpread({}, props), {}, {
    helperText: compInfoHelperText
  }));
}
function OptionsTable(_ref4) {
  var comps = _ref4.comps,
    getItemProps = _ref4.getItemProps,
    getMenuProps = _ref4.getMenuProps,
    onLoadMore = _ref4.onLoadMore,
    hasMore = _ref4.hasMore,
    loading = _ref4.loading;
  return /*#__PURE__*/_jsx(StyledTable, {
    children: /*#__PURE__*/_jsxs(TableBody, _objectSpread(_objectSpread({}, getMenuProps()), {}, {
      children: [_mapInstanceProperty(comps).call(comps, function (comp) {
        return /*#__PURE__*/_jsxs(TableRow, _objectSpread(_objectSpread({}, getItemProps({
          item: comp
        })), {}, {
          hover: true,
          style: {
            cursor: "pointer"
          },
          tabIndex: -1,
          "data-testid": "comp--suggestion",
          children: [/*#__PURE__*/_jsx(TableCell, {
            scope: "row",
            children: comp.displayLabel
          }), /*#__PURE__*/_jsx(TableCell, {
            children: /*#__PURE__*/_jsx(NumberFormatter, {
              value: comp.sqft,
              suffix: " sqft"
            })
          }), /*#__PURE__*/_jsx(TableCell, {
            children: comp.leaseType
          }), /*#__PURE__*/_jsx(TableCell, {
            children: comp.compListingState && /*#__PURE__*/_jsx(StatusBadge, {
              listingState: comp.compListingState
            })
          })]
        }), comp.id);
      }), hasMore && /*#__PURE__*/_jsx(TableRow, {
        hover: true,
        style: {
          cursor: "pointer"
        },
        onClick: onLoadMore,
        children: /*#__PURE__*/_jsxs(TableCell, {
          scope: "row",
          variant: "footer",
          children: ["Load more", " ", loading && /*#__PURE__*/_jsx(Icon, {
            className: "fal fa-spin fa-spinner",
            color: RaiseColors.black,
            fontSize: 14,
            style: {
              marginLeft: 8
            }
          })]
        })
      })]
    }))
  });
}
var StyledTable = withStyles({
  root: {
    minWidth: 400
  }
})(Table);
gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query CompSelectSearchQuery($searchBy: String, $first: Int, $filterBy: JSONString) {\n        allComps(searchBy: $searchBy, first: $first, filterBy: $filterBy) {\n            count\n            pageInfo {\n                hasNextPage\n                endCursor\n            }\n            edges {\n                node {\n                    id\n                    displayLabel # need this for AsyncSelect GET query\n                    compListingState: listingState\n                    isLease\n                    ...CompSelectFragment\n                }\n            }\n        }\n    }\n    ", "\n"])), CompSelectFragment__CompNode);